const rules = [
    {
        pattern: /```(?:([a-zA-Z0-9_+\-]+)\n)?([\s\S]+?)```/,
        build: (match, contentOffset) => ({
            content: match[2] ?? "",
            raw: match[0],
            entity: {
                type: "pre",
                offset: contentOffset,
                length: (match[2] ?? "").length,
                ...(match[1] ? { language: match[1] } : {})
            }
        })
    },
    {
        pattern: /`([^`\n]+)`/,
        build: (match, contentOffset) => ({
            content: match[1] ?? "",
            raw: match[0],
            entity: {
                type: "code",
                offset: contentOffset,
                length: (match[1] ?? "").length
            }
        })
    },
    {
        pattern: /\*\*([^*\n]+)\*\*/,
        build: (match, contentOffset) => ({
            content: match[1] ?? "",
            raw: match[0],
            entity: {
                type: "bold",
                offset: contentOffset,
                length: (match[1] ?? "").length
            }
        })
    },
    {
        pattern: /__([^_\n]+)__/,
        build: (match, contentOffset) => ({
            content: match[1] ?? "",
            raw: match[0],
            entity: {
                type: "underline",
                offset: contentOffset,
                length: (match[1] ?? "").length
            }
        })
    },
    {
        pattern: /(?<![A-Za-z0-9])\*([^*\n]+)\*(?![A-Za-z0-9])/,
        build: (match, contentOffset) => ({
            content: match[1] ?? "",
            raw: match[0],
            entity: {
                type: "italic",
                offset: contentOffset,
                length: (match[1] ?? "").length
            }
        })
    },
    {
        pattern: /(?<![A-Za-z0-9])_([^_\n]+)_(?![A-Za-z0-9])/,
        build: (match, contentOffset) => ({
            content: match[1] ?? "",
            raw: match[0],
            entity: {
                type: "italic",
                offset: contentOffset,
                length: (match[1] ?? "").length
            }
        })
    },
    {
        pattern: /~~([^~\n]+)~~/,
        build: (match, contentOffset) => ({
            content: match[1] ?? "",
            raw: match[0],
            entity: {
                type: "strike",
                offset: contentOffset,
                length: (match[1] ?? "").length
            }
        })
    },
    {
        pattern: /\|\|([^|\n]+)\|\|/,
        build: (match, contentOffset) => ({
            content: match[1] ?? "",
            raw: match[0],
            entity: {
                type: "spoiler",
                offset: contentOffset,
                length: (match[1] ?? "").length
            }
        })
    },
    {
        pattern: /\[([^\]\n]+)\]\((https?:\/\/[^\s)]+)\)/,
        build: (match, contentOffset) => ({
            content: match[1] ?? "",
            raw: match[0],
            entity: {
                type: "link",
                offset: contentOffset,
                length: (match[1] ?? "").length,
                url: match[2] ?? ""
            }
        })
    }
];
const findEarliestMatch = (input) => {
    let best = null;
    for (let index = 0; index < rules.length; index += 1) {
        const rule = rules[index];
        rule.pattern.lastIndex = 0;
        const match = rule.pattern.exec(input);
        if (!match) {
            continue;
        }
        if (!best || match.index < best.match.index) {
            best = { ruleIndex: index, match };
        }
    }
    return best;
};
export const parseMarkdown = (input) => {
    let cursor = 0;
    let plainText = "";
    const entities = [];
    while (cursor < input.length) {
        const remaining = input.slice(cursor);
        const matched = findEarliestMatch(remaining);
        if (!matched) {
            plainText += remaining;
            cursor = input.length;
            break;
        }
        const before = remaining.slice(0, matched.match.index);
        plainText += before;
        const built = rules[matched.ruleIndex].build(matched.match, plainText.length);
        plainText += built.content;
        entities.push(built.entity);
        cursor += matched.match.index + built.raw.length;
    }
    return { text: plainText, entities };
};
export const hasMarkdownSyntax = (input) => /(\*\*[^*\n]+\*\*|__[^_\n]+__|~~[^~\n]+~~|\|\|[^|\n]+\|\||`[^`\n]+`|```[\s\S]+?```|\[[^\]]+\]\(https?:\/\/[^\s)]+\)|(?<![A-Za-z0-9])[*_][^*_\n]+[*_](?![A-Za-z0-9]))/.test(input);
//# sourceMappingURL=markdown.js.map